import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aem-content-fragment-editor"
    }}>{`AEM Content Fragment Editor`}</h1>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-manager.html"
      }}>{`AEM`}</a>{` Content Fragment Editor is a UI service that provides a user-friendly way to edit structure content using Content Fragments within Adobe Experience Manager (AEM).`}</p>
    <p>{`In this section, you will find the available extension points and examples of how to utilize them.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/5530d/cf-editor.webp 320w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/0c8fb/cf-editor.webp 640w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/94b1e/cf-editor.webp 1280w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/0b34d/cf-editor.webp 1920w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/d5269/cf-editor.webp 2560w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/e2a73/cf-editor.webp 2826w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/dd4a7/cf-editor.png 320w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/0f09e/cf-editor.png 640w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/bbbf7/cf-editor.png 1280w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/ac7a9/cf-editor.png 1920w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/c7a69/cf-editor.png 2560w", "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/893ad/cf-editor.png 2826w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/21cbfeced3d9e247e7fc9e04db01d8db/bbbf7/cf-editor.png",
            "alt": "Content Fragment Editor",
            "title": "Content Fragment Editor",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      